export default __webpack_public_path__ + "static/media/action-spinner.50935bd2.png";